import { Box, Button, Flex, Text, Wrap, WrapItem } from '@chakra-ui/react'

const ToggleButton = ({
  label,
  selected,
  onClick,
}: {
  label: string
  selected: boolean
  onClick: () => void
}) => (
  <Button
    size="sm"
    variant={selected ? 'solid' : 'outline'}
    colorScheme={selected ? 'green' : 'gray'}
    onClick={onClick}>
    {label}
  </Button>
)

export function ToggleSelectGroup<T extends string>({
  title,
  options,
  getLabel,
  selected,
  onToggle,
  onToggleAll,
}: {
  title: string
  options: readonly T[]
  getLabel: (value: T) => string
  selected: T[]
  onToggle: (value: T) => void
  onToggleAll: () => void
}) {
  const allSelected = selected.length === options.length
  return (
    <Box>
      <Flex align="center" justify="space-between" mb={2}>
        <Text fontWeight="500" fontSize="sm" color="gray.700">
          {title}
        </Text>
        <Button size="sm" variant="link" colorScheme="green" onClick={onToggleAll}>
          {allSelected ? 'Deselect All' : 'Select All'}
        </Button>
      </Flex>
      <Wrap spacing={2}>
        {options.map(option => (
          <WrapItem key={option}>
            <ToggleButton
              label={getLabel(option)}
              selected={selected.includes(option)}
              onClick={() => onToggle(option)}
            />
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  )
}
